<div class="login-container">
  <div class="login-card">
    <div class="login-card-isotipo">
      <img src="img/logo.png" alt="" srcset="">
    </div>
    
    <h2 class="login-subtitle">Restablecer contraseña</h2>
    <p class="login-description">
      Ingresa tu nueva contraseña y confírmala para completar el proceso de actualización.
    </p>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="input-group">
        <label class="input-label">Nueva contraseña</label>
        <p-password 
          formControlName="password"
          [toggleMask]="true"
          [feedback]="false"
          placeholder="**************"
          class="custom-input"
          [inputStyleClass]="(submitted || f['password'].touched) && f['password'].errors ? 'custom-input input-error' : 'custom-input'"
        ></p-password>
        <div *ngIf="(submitted || f['password'].touched) && f['password'].errors" class="error-message">
          <div *ngIf="f['password'].errors['required']">La contraseña es requerida</div>
          <div *ngIf="f['password'].errors['minlength']">La contraseña debe tener al menos 8 caracteres</div>
        </div>
      </div>
      <div class="input-group">
        <label class="input-label">Repetir contraseña</label>
        <p-password 
          formControlName="passwordRepited"
          [toggleMask]="true"
          [feedback]="false"
          placeholder="**************"
          class="custom-input"
          [inputStyleClass]="(submitted || f['passwordRepited'].touched) && (f['passwordRepited'].errors || loginForm.errors?.['passwordsMismatch']) ? 'custom-input input-error' : 'custom-input'"
        ></p-password>
        <div *ngIf="(submitted || f['passwordRepited'].touched) && (f['passwordRepited'].errors || loginForm.errors?.['passwordsMismatch'])" class="error-message">
          <div *ngIf="f['passwordRepited'].errors?.['required']">La contraseña es requerida</div>
          <div *ngIf="f['passwordRepited'].errors?.['minlength']">La contraseña debe tener al menos 8 caracteres</div>
          <div *ngIf="f['passwordRepited'].errors?.['passwordsMismatch'] || loginForm.errors?.['passwordsMismatch']">Las contraseñas no coinciden</div>
        </div>
      </div>

      <button 
        pButton 
        type="submit" 
        class="login-button"
        [disabled]="loginForm.invalid"
      >
        Restablecer
     </button>
    </form>
  </div>
  <p-toast></p-toast>
</div>
